"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = require("@material-ui/core/colors");

var accent = {
  greenDark: _colors.green[900],
  greenLight: _colors.green[200],
  greenMain: _colors.green[500],
  limeDark: _colors.lime[900],
  limeLight: _colors.lime[200],
  limeMain: _colors.lime[500],
  orangeDark: _colors.orange[900],
  orangeLight: _colors.orange[200],
  orangeMain: _colors.orange[500],
  redDark: _colors.red[900],
  redLight: _colors.red[200],
  redMain: _colors.red[500],
  tealDark: _colors.teal[900],
  tealLight: _colors.teal[200],
  tealMain: _colors.teal[500]
};
var _default = accent;
exports["default"] = _default;